import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';

import { useToggle } from 'react-use';
import { ReactComponent as ArrayIcon } from '../../../../components/elements/customModals/AccountSettingsModal/PaymentSection/ArrayIcon.svg';
import { useNavigate } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes';
import { updateUser } from '../../../../firebase/api/users';
import { useAuth } from '../../../../hooks/useAuth';
import { ReactComponent as CloseIcon } from './close-modal.svg';
import './styles.css';

const WelcomeModal = ({ openState = true }) => {
    const [isOpen, toggleOpenStatus] = useToggle(false);
    const { currentUser } = useAuth();

    useEffect(() => {
        if (openState) {
            updateUser({ uid: currentUser.uid, alreadySeeWelcomePopup: true }).catch(console.error);
        }

        toggleOpenStatus(openState);
    }, [openState]);

    const navigate = useNavigate();

    const handleNavigateToCreate = useCallback(() => {
        toggleOpenStatus();
        navigate(ROUTES.CREATE_POST);
    }, [navigate, toggleOpenStatus]);

    return (
        <Modal isOpen={isOpen} className="welcome-modal">
            <ModalBody className="welcome-modal__container">
                <button onClick={toggleOpenStatus} className="welcome-modal_close">
                    <CloseIcon />
                </button>
                <h1 className="welcome-modal__title mb-3">Welcome to the Sidekick Community!</h1>
                <div className="welcome-modal__text mb-3">
                    Whether you&apos;re a freelancer, startup or agency, our platform is here to
                    help you find the right people for your projects. These are some of the things
                    you can do...
                </div>
                <div className="welcome-modal__description mb-5">
                    <ul>
                        <li>Get professional support with your projects</li>
                        <li>Invite friends and colleagues to collaborate</li>
                        <li>Post projects publicly to expand your network</li>
                        <li>Create curated and specialised teams</li>
                        <li>Manage freelancer availability</li>
                        <li>Get last minute projects completed effortlessly</li>
                    </ul>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                    <button
                        className="welcome-modal__button"
                        type="button"
                        onClick={handleNavigateToCreate}
                    >
                        Go forth and create
                        <div className="ml-2">
                            <ArrayIcon />
                        </div>
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};

WelcomeModal.propTypes = {
    openState: PropTypes.bool.isRequired,
};

export default React.memo(WelcomeModal);
